import $ from "jquery";
import AjaxDataSend from "../elements/shopEcp/ajaxDataSend.js";

const industry = document.querySelector("#filter-industry");
const industryInput = industry.querySelector(".ns-singleselect__input");
/* const industryTitle = industry.querySelector(".ns-singleselect__title"); */
const targetRegion = document.querySelector("#filter-target-region");
const targetRegionSelectInput = targetRegion.querySelector(
    ".ns-multiselect__input"
);
const targetRegionCheckboxInputs = targetRegion.querySelectorAll(
    ".ns-checkbox__input"
);
const targetCountry = document.querySelector("#filter-target-country");
const paymentType = document.querySelector("#filter-payment-type");

const industryMobile = document.querySelector(
    '.ns-singleselect-mobile__frame[data-tag="industry"]'
);
const industryMobileInputs =
    industryMobile.querySelectorAll(".ns-radio__input");
const targetRegionMobile = document.querySelector(
    '.ns-multiselect-mobile__frame[data-tag="targetRegion"]'
);
const targetRegionMobileInputs = targetRegionMobile.querySelectorAll(
    ".ns-checkbox__input"
);
const targetCountryMobile = document.querySelector(
    "#mobile-filter-target-country"
);
const targetCountryFrameMobile = document.querySelector(
    '.ns-multiselect-mobile__frame[data-tag="targetCountry"]'
);
const targetCountryItemsMobile = targetCountryFrameMobile.querySelectorAll(
    ".ns-multiselect-mobile__frame-list-item"
);
const paymentTypeMobile = document.querySelector("#mobile-filter-payment-type");
const paymentTypeFrameMobile = document.querySelector(
    '.ns-multiselect-mobile__frame[data-tag="paymentType"]'
);

const containerMobile = document.querySelector(
    ".ns-customer-stories-mobile-filter"
);

let isAjax = false;
let isFullFilter = false;

const customControlsForKeyActivation =
    '.ns-multiselect-tab, ' +
    '.ns-multiselect-mobile__frame-tab, ' +
    '.ns-singleselect-mobile__frame-top-back, ' +
    '.ns-multiselect-mobile__frame-top-back, ' +
    '.ns-multiselect__select-all, ' +
    '.ns-multiselect__deselect-all, ' +
    '.ns-multiselect__confirm-selection, ' +
    '.ns-multiselect-mobile__frame-top-all-select, ' +
    '.ns-multiselect-mobile__frame-top-all-deselect'
;

document.querySelectorAll(customControlsForKeyActivation).forEach(tab => {
    tab.addEventListener('keydown',(e)=>{
        if(e.code === "Enter" || e.code === "Space"){
            e.preventDefault();
            e.target.click();
        }
    });
});

industry.addEventListener('change', () => {
    if (industryInput.value && targetRegionSelectInput.value) {

        targetCountry.classList.remove('ns-multiselect--disabled');
        targetCountry.removeAttribute('inert');
        paymentType.classList.remove('ns-multiselect--disabled');
        paymentType.removeAttribute('inert');
        isFullFilter = true;
        getPaymentMethods();
    } else {
        targetCountry.classList.add('ns-multiselect--disabled');
        targetCountry.setAttribute('inert', 'true');
        paymentType.classList.add('ns-multiselect--disabled');
        paymentType.setAttribute('inert', 'true');
        isFullFilter = false;
    }
});

targetRegion.addEventListener("change", () => {
    for (const targetRegionCheckboxInput of targetRegionCheckboxInputs) {
        const targetCountryTabRegions = targetCountry.querySelector(
            `.ns-multiselect__regions li[data-region='${targetRegionCheckboxInput.value}']`
        );
        const targetCountryInputs = targetCountry.querySelectorAll(
            `.ns-multiselect__list li[data-region='${targetRegionCheckboxInput.value}'] input`
        );

        if (targetRegionCheckboxInput.checked) {
            targetCountryTabRegions.classList.remove(
                "ns-multiselect__region--off"
            );

            for (const targetCountryInput of targetCountryInputs) {
                if (!targetCountryInput.checked) {
                    targetCountryInput.click();
                }
            }
        } else {
            targetCountryTabRegions.classList.add(
                "ns-multiselect__region--off"
            );

            for (const targetCountryInput of targetCountryInputs) {
                if (targetCountryInput.checked) {
                    targetCountryInput.click();
                }
            }
        }
    }

    const targetCountryFirstTabRegion = targetCountry.querySelector(
        `.ns-multiselect__regions li:not(.ns-multiselect__region--off)`
    );

    if (targetCountryFirstTabRegion) {
        targetCountryFirstTabRegion.click();
    }

    targetRegion.querySelector(".ns-multiselect__title").click();

    if (industryInput.value && targetRegionSelectInput.value) {
        targetCountry.classList.remove('ns-multiselect--disabled');
        targetCountry.removeAttribute('inert');
        paymentType.classList.remove('ns-multiselect--disabled');
        paymentType.removeAttribute('inert');
        isFullFilter = true;
        getPaymentMethods();
    } else {
        targetCountry.classList.add('ns-multiselect--disabled');
        targetCountry.setAttribute('inert', 'true');
        paymentType.classList.add('ns-multiselect--disabled');
        paymentType.setAttribute('inert', 'true');
        isFullFilter = false;
    }
});

targetCountry.addEventListener("change", () => {
    if (industryInput.value && targetRegionSelectInput.value) {
        getPaymentMethods();
    }
});

paymentType.addEventListener("change", () => {
    if (industryInput.value && targetRegionSelectInput.value) {
        getPaymentMethods();
    }
});

document.querySelectorAll(".ns-shop__clear").forEach((e) => {
    e.addEventListener("click", () => {
        const request = new XMLHttpRequest();
        request.onload = () => {
            window.location.replace(window.location.pathname);
        };
        request.open("GET", "/ajax/shop-clear-filter/");
        request.send();

        /*const industryChecked = industry.querySelector('input:checked');

        if (industryChecked) {
            industry.querySelector('input:checked').checked = false;
            industryTitle.textContent = industryTitle.dataset.title;
        }

        const targetRegionsChecked = targetRegion.querySelectorAll('input:checked');

        if (targetRegionsChecked) {
            for (const targetRegionChecked of targetRegionsChecked) {
                targetRegionChecked.click();
            }
        }

        const paymentTypesChecked = paymentType.querySelectorAll('input:checked');

        if (paymentTypesChecked) {
            for (const paymentTypeChecked of paymentTypesChecked) {
                paymentTypeChecked.click();
            }
        }

        const industryCheckedMobile = industryMobile.querySelector('input:checked');

        if (industryCheckedMobile) {
            industryCheckedMobile.checked = false;
        }

        const targetRegionsCheckedMobile = targetRegionMobile.querySelectorAll('input:checked');

        if (targetRegionsCheckedMobile) {
            for (const targetRegionCheckedMobile of targetRegionsCheckedMobile) {
                targetRegionCheckedMobile.click();
            }
        }

        const paymentTypesCheckedMobile = paymentTypeFrameMobile.querySelectorAll('input:checked');

        if (paymentTypesCheckedMobile) {
            for (const paymentTypeCheckedMobile of paymentTypesCheckedMobile) {
                paymentTypeCheckedMobile.click();
            }
        }*/
    });
});

const handleChangeRegions = () => {
    const tabs = targetCountryFrameMobile.querySelectorAll(
        ".ns-multiselect-mobile__frame-tab"
    );
    let activeRegion = null;

    for (const tab of tabs) {
        const isChecked = targetRegionMobile.querySelector(
            `.ns-checkbox__input[value='${tab.dataset.region}']:checked`
        );
        const items = targetCountryFrameMobile.querySelectorAll(
            `.ns-multiselect-mobile__frame-list-item[data-region='${tab.dataset.region}']`
        );

        if (isChecked) {
            tab.style.display = "list-item";

            if (!activeRegion) {
                tab.classList.add("ns-multiselect-mobile__frame-tab--active");

                for (const item of items) {
                    const input = item.querySelector(".ns-checkbox__input");

                    if (!input.checked) {
                        input.click();
                    }

                    item.style.display = "list-item";
                }

                activeRegion = tab.dataset.region;
            } else {
                tab.classList.remove(
                    "ns-multiselect-mobile__frame-tab--active"
                );

                for (const item of items) {
                    const input = item.querySelector(".ns-checkbox__input");

                    if (!input.checked) {
                        input.click();
                    }

                    item.style.display = "none";
                }
            }
        } else {
            tab.classList.remove("ns-multiselect-mobile__frame-tab--active");
            tab.style.display = "none";

            for (const item of items) {
                const input = item.querySelector(".ns-checkbox__input");

                if (input.checked) {
                    input.click();
                }

                item.style.display = "none";
            }
        }
    }
};

const handleChangeMainFilters = () => {
    const countIndustriesChecked = industryMobile.querySelectorAll(
        ".ns-radio__input:checked"
    ).length;
    const countTargetRegionsChecked = targetRegionMobile.querySelectorAll(
        ".ns-checkbox__input:checked"
    ).length;

    if (countIndustriesChecked && countTargetRegionsChecked) {
        targetCountryMobile.classList.remove('ns-multiselect-mobile--disabled');
        targetCountryMobile.removeAttribute('inert');
        paymentTypeMobile.classList.remove('ns-multiselect-mobile--disabled');
        paymentTypeMobile.removeAttribute('inert');
    } else {
        paymentTypeMobile.classList.add('ns-multiselect-mobile--disabled');
        paymentTypeMobile.setAttribute('inert', 'true');
        targetCountryMobile.classList.add('ns-multiselect-mobile--disabled');
        targetCountryMobile.setAttribute('inert', 'true');
    }
};

for (const industryMobileInput of industryMobileInputs) {
    industryMobileInput.addEventListener("change", handleChangeMainFilters);
}

for (const targetRegionMobileInput of targetRegionMobileInputs) {
    targetRegionMobileInput.addEventListener("change", () => {
        handleChangeMainFilters();
        handleChangeRegions();
    });
}

const initMobileFilter = () => {
    const $openButton = document.querySelector(
        ".ns-customer-stories__mobile-open"
    );
    const $clearButton = document.querySelector(
        ".ns-customer-stories__mobile-controls .ns-customer-stories__clear"
    );

    const fields = containerMobile.querySelectorAll(".ns-multiselect");
    const $containerClearFilter = containerMobile.querySelector(
        ".ns-customer-stories-mobile-filter__clear"
    );
    const $closeButton = containerMobile.querySelector(
        ".ns-customer-stories-mobile-filter__close"
    );
    const $form = containerMobile.querySelector(
        ".ns-customer-stories-mobile-filter__form"
    );

    const industryMobileButton = document.querySelector('.ns-singleselect-mobile__title[data-tag="industry"]');
    const targetRegionMobileButton = document.querySelector('.ns-multiselect-mobile__title[data-tag="targetRegion"]');
    const targetCountryMobileButton = document.querySelector('.ns-multiselect-mobile__title[data-tag="targetCountry"]');
    const paymentTypeMobileButton = document.querySelector('.ns-multiselect-mobile__title[data-tag="paymentType"]');
    const backToFilterListSingleselect = document.querySelector('.ns-singleselect-mobile__frame-top-back');
    const backToFilterListMultiselect = document.querySelectorAll('.ns-multiselect-mobile__frame-top-back');
    const singleselectMobileFrameConfirmButtom = document.querySelector('.ns-singleselect-mobile__frame-confirm');
    const multiselectMobileFrameConfirmButtom = document.querySelectorAll('.ns-multiselect-mobile__frame-confirm');

    const inertOnModalOn = () => {
        // inert on site root elements
        const firstLevelBodyNodes = document.querySelectorAll('body > *');
        firstLevelBodyNodes.forEach((node) => {
            node.setAttribute('inert', 'true');
        });
        const firstLevelMainNodes = document.querySelectorAll('.ns-main > *');
        firstLevelMainNodes.forEach((node) => {
            node.setAttribute('inert', 'true');
        });
        const firstLevelContentNodes = document.querySelectorAll('.ns-content > *');
        firstLevelContentNodes.forEach((node) => {
            node.setAttribute('inert', 'true');
        });
        const filterRootContainerElements = document.querySelectorAll(".ns-wrapper--shop > *:not(.ns-customer-stories-mobile-filter)");
        // inert on non-modal filter elements
        filterRootContainerElements.forEach((node) => {
            node.setAttribute('inert', 'true');
        });
        // clear inert on modal tree
        const mobileFilterContainer = document.querySelector(".ns-customer-stories-mobile-filter");
        let mobileFilterParentNode = mobileFilterContainer.parentNode;
        while(mobileFilterParentNode.nodeName !== "BODY"){
            console.dir(mobileFilterParentNode);
            mobileFilterParentNode.removeAttribute('inert');
            mobileFilterParentNode = mobileFilterParentNode.parentNode;
        }
        // focus on first modal element
        document.querySelector(".ns-customer-stories-mobile-filter__close").focus();
    };

    const inertOnModalOff = () => {
        const firstLevelBodyNodes = document.querySelectorAll('body > *');
        firstLevelBodyNodes.forEach((node) => {
            node.removeAttribute('inert');
        });
        const firstLevelMainNodes = document.querySelectorAll('.ns-main > *');
        firstLevelMainNodes.forEach((node) => {
            node.removeAttribute('inert');
        });
        const firstLevelContentNodes = document.querySelectorAll('.ns-content > *');
        firstLevelContentNodes.forEach((node) => {
            node.removeAttribute('inert');
        });
        const filterRootContainerElements = document.querySelectorAll(".ns-wrapper--shop > *:not(.ns-customer-stories-mobile-filter)");
        // inert on non-modal filter elements
        filterRootContainerElements.forEach((node) => {
            node.removeAttribute('inert');
        });
    };

    const handleOpen = () => {
        containerMobile.classList.add("ns-customer-stories-mobile-filter--active");
        document.body.style.overflowY = 'hidden';
        inertOnModalOn();
    };

    const handleClose = () => {
        containerMobile.classList.remove(
            "ns-customer-stories-mobile-filter--active"
        );
        document.body.style.overflowY = "visible";
        inertOnModalOff();
    };

    const handleDropFilters = () => {
        fields.forEach(($field) => {
            $field.dispatchEvent(new CustomEvent("handle-clear-value"));
        });
    };

    const handleClear = () => {
        handleDropFilters();

        onSubmitForm();
    };

    industryMobileButton.addEventListener("click",(e) => {
        inertOnOpenMobileTab(e.target);
    });
    targetRegionMobileButton.addEventListener("click",(e) => {
        inertOnOpenMobileTab(e.target);
    });
    targetCountryMobileButton.addEventListener("click",(e) => {
        inertOnOpenMobileTab(e.target);
    });
    paymentTypeMobileButton.addEventListener("click",(e) => {
        inertOnOpenMobileTab(e.target);
    });
    backToFilterListSingleselect.addEventListener("click",(e) => {
        const target = document.querySelector(`.ns-singleselect-mobile__title[data-tag="${e.target.parentNode.parentNode.dataset.tag}"]`);
        removeInertOnCloseMobileTab(target);

    });
    backToFilterListMultiselect.forEach((button)=>{
        button.addEventListener("click",(e) => {
            let tag = "";
            if(e.target.parentNode.parentNode.parentNode.classList.contains("ns-multiselect-mobile__frame--big")){
                tag = e.target.parentNode.parentNode.parentNode.dataset.tag;
            }
            else{
                tag = e.target.parentNode.parentNode.dataset.tag;
            }
            const target = document.querySelector(`.ns-multiselect-mobile__title[data-tag="${tag}"]`);
            removeInertOnCloseMobileTab(target);
        });
    });
    singleselectMobileFrameConfirmButtom.addEventListener("click",(e) => {
        const target = document.querySelector(`.ns-singleselect-mobile__title[data-tag="${e.target.parentNode.dataset.tag}"]`);
        removeInertOnCloseMobileTab(target);
    });
    multiselectMobileFrameConfirmButtom.forEach((button)=>{
        button.addEventListener("click",(e) => {
            const target = document.querySelector(`.ns-multiselect-mobile__title[data-tag="${e.target.parentNode.dataset.tag}"]`);
            removeInertOnCloseMobileTab(target);
        });
    });
    const inertOnOpenMobileTab = (target) => {
        target.parentNode.parentNode.parentNode.parentNode.setAttribute('inert', 'true');
    };

    const removeInertOnCloseMobileTab = (target) => {
        target.parentNode.parentNode.parentNode.parentNode.removeAttribute('inert');
        target.focus();
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const industryMobileValue = industryMobile.querySelector(
            ".ns-radio__input:checked"
        ).value;
        let targetRegionMobileValue = "";

        for (const regionChecked of targetRegionMobile.querySelectorAll(
            ".ns-checkbox__input:checked"
        )) {
            if (targetRegionMobileValue === "") {
                targetRegionMobileValue = regionChecked.value;
            } else {
                targetRegionMobileValue += `,${regionChecked.value}`;
            }
        }

        let targetCountryMobileValue = "";

        for (const countryChecked of targetCountryFrameMobile.querySelectorAll(
            ".ns-checkbox__input:checked"
        )) {
            if (targetCountryMobileValue === "") {
                targetCountryMobileValue = countryChecked.value;
            } else {
                targetCountryMobileValue += `,${countryChecked.value}`;
            }
        }

        let paymentTypeMobileValue = "";

        for (const paymentTypeChecked of paymentTypeFrameMobile.querySelectorAll(
            ".ns-checkbox__input:checked"
        )) {
            if (paymentTypeMobileValue === "") {
                paymentTypeMobileValue = paymentTypeChecked.value;
            } else {
                paymentTypeMobileValue += `,${paymentTypeChecked.value}`;
            }
        }

        industryInput.value = industryMobileValue;
        targetRegionSelectInput.value = targetRegionMobileValue;
        targetCountry.querySelector(".ns-multiselect__input").value =
            targetCountryMobileValue;
        paymentType.querySelector(".ns-multiselect__input").value =
            paymentTypeMobileValue;
        getPaymentMethods();
        handleClose();
    };

    $openButton.addEventListener("click", handleOpen);

    $closeButton.addEventListener("click", handleClose);

    $form.addEventListener("submit", (e) => handleSubmit(e));
};

const init = () => {
    initMobileFilter();

    const selectIndustry = industryInput.dataset.valueDefault;

    if (selectIndustry) {
        industry.querySelector(`input[value='${selectIndustry}']`).click();
        industryMobile
            .querySelector(`input[value='${selectIndustry}']`)
            .click();
    }

    const selectTargetRegions = targetRegionSelectInput.dataset.valueDefault;
    const selectTargetCountry = targetCountry.querySelector(
        ".ns-multiselect__input"
    ).dataset.valueDefault;
    let selectCountries = [];

    if (selectTargetCountry) {
        selectCountries = selectTargetCountry.split(",");
    }

    if (selectTargetRegions) {
        for (const selectTargetRegion of selectTargetRegions.split(",")) {
            targetRegion
                .querySelector(`input[value='${selectTargetRegion}']`)
                .click();
            targetRegionMobile
                .querySelector(`input[value='${selectTargetRegion}']`)
                .click();

            if (selectTargetCountry) {
                const countriesRegion = targetCountry.querySelectorAll(
                    `.ns-multiselect__item[data-region='${selectTargetRegion}'] input`
                );
                const countriesRegionMobile =
                    targetCountryFrameMobile.querySelectorAll(
                        `.ns-multiselect-mobile__frame-list-item[data-region='${selectTargetRegion}'] input`
                    );

                for (const country of countriesRegion) {
                    if (selectCountries.indexOf(country.value) === -1) {
                        country.click();
                    }
                }

                for (const country of countriesRegionMobile) {
                    if (selectCountries.indexOf(country.value) === -1) {
                        country.click();
                    }
                }
            }
        }
    }

    const selectPaymentTypes = paymentType.querySelector(
        ".ns-multiselect__input"
    ).dataset.valueDefault;

    if (selectPaymentTypes) {
        for (const selectPaymentType of selectPaymentTypes) {
            paymentType
                .querySelector(`input[value='${selectPaymentType}']`)
                .click();
            paymentTypeFrameMobile
                .querySelector(`input[value='${selectPaymentType}']`)
                .click();
        }
    }

    isAjax = true;
};

let timeoutId;

const getPaymentMethods = () => {
    if (!isAjax) {
        return;
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
        const businessType = industryInput.value;
        const targetRegions = targetRegionSelectInput.value;
        const targetCountries = targetCountry.querySelector(
            ".ns-multiselect__input"
        ).value;
        const paymentDirection = paymentType.querySelector(
            ".ns-multiselect__input"
        ).value;
        const request = new XMLHttpRequest();
        request.onload = () => {
            const response = JSON.parse(request.responseText);
            const countPaymentMethods =
                document.querySelector("#totalCountText");

            if (response.length === 0) {
                countPaymentMethods.textContent =
                    countPaymentMethods.dataset.noMatchText;
            } else if (response.length === 1) {
                countPaymentMethods.textContent =
                    countPaymentMethods.dataset.oneMethodText;
            } else {
                countPaymentMethods.textContent =
                    countPaymentMethods.dataset.countText.replace(
                        "#total#",
                        response.length
                    );
            }

            const template = document.querySelector("#template_payment_method");
            template.parentNode.querySelector(
                ".store__methods-grid"
            ).textContent = "";
            let i = 0;

            for (const paymentMethod of response) {
                const logo =
                    paymentMethod.logo_url !== ""
                        ? `/uploads${paymentMethod.logo_url}`
                        : "/dist/assets/img/design/shopEcp/No-logo.svg";
                const clone = template.content.cloneNode(true);

                if (i >= 30) {
                    clone.querySelector(".store__method-item").style.display =
                        "none";
                }

                clone.querySelector("input").value = paymentMethod.name;
                clone.querySelector(".store__method-item-img img").src = logo;
                clone.querySelector(
                    ".store__method-item-main-name"
                ).textContent = paymentMethod.nameSeparatedParts.pmNameMain;
                clone.querySelector(
                    ".store__method-item-additional-name"
                ).textContent =
                    paymentMethod.nameSeparatedParts.pmNameAdditional;
                clone.querySelector(".store__heading_h2").textContent =
                    paymentMethod.name;
                clone.querySelector(".store__heading_h2 + div").innerHTML =
                    paymentMethod.description;

                if (
                    typeof paymentMethod.Details.PaymentMethodType !==
                    "undefined"
                ) {
                    const blockPaymentMethodCategory = clone.querySelector(
                        '.store__heading_h3[data-tag="paymentMethodCategory"] + div p'
                    );

                    for (const paymentMethodCategory of paymentMethod.Details
                        .PaymentMethodType) {
                        const element = document.createElement("span");
                        element.className = "store__text-cloud";
                        element.textContent = paymentMethodCategory;
                        blockPaymentMethodCategory.appendChild(element);
                    }
                }

                if (
                    typeof paymentMethod.Details.AcceptedBusinessTypes !==
                    "undefined"
                ) {
                    const blockSupportedIndustries = clone.querySelector(
                        '.store__heading_h3[data-tag="supportedIndustries"] + div p'
                    );

                    for (const id in paymentMethod.Details
                        .AcceptedBusinessTypes) {
                        if (!blockSupportedIndustries.textContent) {
                            blockSupportedIndustries.textContent =
                                paymentMethod.Details.AcceptedBusinessTypes[id];
                        } else {
                            blockSupportedIndustries.textContent += `, ${paymentMethod.Details.AcceptedBusinessTypes[id]}`;
                        }
                    }
                }

                if (
                    typeof paymentMethod.Details.PaymentDirection !==
                    "undefined"
                ) {
                    const blockPaymentType = clone.querySelector(
                        '.store__heading_h3[data-tag="paymentType"] + div p'
                    );

                    for (const paymentType of paymentMethod.Details
                        .PaymentDirection) {
                        const element = document.createElement("span");
                        element.className = "store__text-cloud";
                        element.textContent = paymentType;
                        blockPaymentType.appendChild(element);
                    }
                }

                if (typeof paymentMethod.Details.Regions !== "undefined") {
                    const blockRegions = clone.querySelector(
                        '.store__heading_h3[data-tag="regions"] + div p'
                    );

                    if (paymentMethod.Details.allRegions !== "true") {
                        blockRegions.textContent = "";

                        for (const region of paymentMethod.Details.Regions) {
                            if (!blockRegions.textContent) {
                                blockRegions.textContent = region;
                            } else {
                                blockRegions.textContent += `, ${region}`;
                            }
                        }
                    }
                }

                if (typeof paymentMethod.Details.Countries !== "undefined") {
                    const blockCountries = clone.querySelector(
                        '.store__heading_h3[data-tag="countries"] + div p'
                    );

                    if (paymentMethod.Details.allCountries !== "true") {
                        blockCountries.textContent = "";
                        let j = 0;

                        for (const country of paymentMethod.Details.Countries) {
                            if (!blockCountries.textContent) {
                                blockCountries.textContent = country;
                            } else if (j <= 5) {
                                blockCountries.textContent += `, ${country}`;
                            } else {
                                blockCountries.textContent += "...";
                                clone.querySelector(
                                    ".shop__show-all-countries_private-pm"
                                ).style.display = "inline";
                                break;
                            }

                            j++;
                        }

                        for (const key in paymentMethod.Details
                            .CountriesModalWindow) {
                            const element = document.createElement("div");
                            element.className =
                                "store__block store__show-all-countries";
                            const h3 = document.createElement("h3");
                            h3.className = "store__heading store__heading_h3";
                            h3.textContent =
                                paymentMethod.Details.CountriesModalWindow[
                                    key
                                ].region;
                            element.appendChild(h3);
                            const countries = document.createElement("spawn");

                            for (const country of paymentMethod.Details
                                .CountriesModalWindow[key].countries) {
                                if (countries.textContent === "") {
                                    countries.textContent = country;
                                } else {
                                    countries.textContent += `, ${country}`;
                                }
                            }

                            element.appendChild(countries);
                            clone
                                .querySelector(".store__target-countries-modal")
                                .appendChild(element);
                        }
                    }
                }

                clone.querySelector(".store__pm-info-general-logo img").src =
                    logo;
                template.parentNode
                    .querySelector(".store__methods-grid")
                    .appendChild(clone);
                i++;
            }

            if (response.length < 30) {
                document.querySelector(
                    ".store__show-all-payment-methods"
                ).style.display = "none";
            } else {
                document.querySelector(
                    ".store__show-all-payment-methods"
                ).style.display = "block";
            }
        };
        request.open(
            "GET",
            `/ajax/get-payment-methods/?businessType=${businessType}&targetRegions=${targetRegions}&targetCountries=${targetCountries}&paymentDirection=${paymentDirection}`
        );
        request.send();
    }, 1000);
};

window.addEventListener("pageshow", function (event) {
    var historyTraversal =
        event.persisted ||
        (typeof window.performance != "undefined" &&
            window.performance.navigation.type === 2);
    if (historyTraversal) {
        // Handle page restore.
        window.location.reload();
    }
});

window.addEventListener("DOMContentLoaded", function () {
    init();
    selectItemCount();

    document
        .getElementById("changePublicSelectionPm")
        .addEventListener("click", (e) => {
            let button = $(e.target);
            let state = button.attr("data-button-state");
            if (state == "select") {
                changeButtonStatus("deselect");
                $('input[name="paymentMethod"]').prop("checked", true);
            } else {
                changeButtonStatus("select");
                $('input[name="paymentMethod"]').prop("checked", false);
            }
            selectItemCount();
            sendPmToSession();
        });

    addEventListener(
        document,
        "click",
        (e) => {
            const $body = document.querySelector("body");
            const $modal = e.target
                .closest(".store__method-item")
                .querySelector(".store__modal");
            const $closeButton = $modal.querySelector(".store__modal-close");

            $body.style.overflow = "hidden";

            $modal.classList.add("store__modal--show");

            $closeButton.focus();
        },
        ".store__method-item-text-container"
    );

    addEventListener(
        document.querySelector(".store__methods-grid"),
        "click",
        (e) => {
            e.target
                .closest(".store__modal--show")
                .classList.remove("store__modal--show");
            document.querySelector("body").style.overflow = "unset";
        },
        ".store__modal-close"
    );

    addEventListener(
        document.querySelector(".store__methods-grid"),
        "click",
        (e) => {
            if (!e.target.classList.contains("store__modal--show")) {
                return;
            }
            e.target.classList.remove("store__modal--show");
            document.querySelector("body").style.overflow = "unset";
        },
        ".store__modal--show"
    );

    addEventListener(
        document.querySelector(".store__methods-grid"),
        "click",
        (e) => {
            e.preventDefault();
            e.target
                .closest(".store__modal-text-column")
                .querySelector(".store__modal-second-level").style.display =
                "block";
        },
        ".shop__show-all-countries_private-pm"
    );

    addEventListener(
        document.querySelector(".store__methods-grid"),
        "click",
        (e) => {
            e.target.closest(".store__modal-second-level").style.display =
                "none";
        },
        ".store__heading-countries-back-arrow"
    );

    addEventListener(
        document.querySelector(".store__container"),
        "click",
        (e) => {
            let scrollY = window.scrollY;
            $(".store__method-item").slideDown(1000);
            $(e.target).parent().slideUp(1000);
            window.scroll(0, scrollY);
        },
        "#showAllPaymentMethods"
    );

    addEventListener(
        document.querySelector(".store__methods-grid"),
        "change",
        (e) => {
            selectItemCount();
            sendPmToSession();
        },
        "input"
    );

    window.addEventListener("scroll", floatButtonView);
    floatButtonView();
});

function floatButtonView() {
    const floatButtonStatic = document.querySelector(
        ".store__floating-button-container--static"
    );
    const footer = document.querySelector(".ns-footer");
    const floatButtonFloat = document.querySelector(
        ".store__floating-button-container--fixed"
    );
    if (
        window.scrollY >
            floatButtonStatic.offsetTop + floatButtonStatic.clientHeight &&
        window.scrollY + window.innerHeight < footer.offsetTop
    ) {
        floatButtonFloat.classList.add(
            "store__floating-button-container--fixed-show"
        );
        floatButtonFloat.removeAttribute("inert");
    } else {
        floatButtonFloat.classList.remove(
            "store__floating-button-container--fixed-show"
        );
        floatButtonFloat.setAttribute("inert", "true");
    }
}

function addEventListener(el, eventName, eventHandler, selector) {
    if (selector) {
        const wrappedHandler = (e) => {
            if (!e.target) return;
            const el = e.target.closest(selector);
            if (el) {
                eventHandler.call(el, e);
            }
        };
        el.addEventListener(eventName, wrappedHandler);
        return wrappedHandler;
    } else {
        const wrappedHandler = (e) => {
            eventHandler.call(el, e);
        };
        el.addEventListener(eventName, wrappedHandler);
        return wrappedHandler;
    }
}

function selectItemCount() {
    if ($("#selectCountText").length == 0) {
        return;
    }
    let totalPm = $('input[name="paymentMethod"]').length;
    switch (totalPm) {
        case 0: {
            let totalText = $("#totalCountText").attr("data-no-match-text");
            $("#totalCountText").html(totalText);
            break;
        }
        case 1: {
            let totalText = $("#totalCountText").attr("data-one-method-text");
            $("#totalCountText").html(totalText);
            break;
        }
        default: {
            let totalText = $("#totalCountText").attr("data-count-text");
            totalText = totalText.replace("#total#", totalPm);
            $("#totalCountText").html(totalText);
            break;
        }
    }
    let checkedPm = $('input[name="paymentMethod"]:checked').length;
    let targetText =
        checkedPm == 1
            ? $("#selectCountText").attr("data-one-method-select-text")
            : $("#selectCountText").attr("data-select-count-text");
    //"#current# of #total# Payment Methods Selected"
    targetText = targetText.replace("#current#", checkedPm);
    $("#selectCountText").html(targetText);
    $("#selectCountTextFloat").html(targetText);
}

function sendPmToSession() {
    let formData = {};
    let paymentMethodsControls = $('input[name="paymentMethod"]:checked');
    formData.paymentMethods = [];
    paymentMethodsControls.each(function (index, control) {
        formData.paymentMethods.push($(control).val());
    });
    AjaxDataSend({
        url: "/ajax/shop-selection-save-pm-to-session/",
        data: formData,
        onSuccess: function (response) {},
        onError: function (response) {},
        onComplete: function (response) {},
        beforeSend: function () {},
    });
}

function changeButtonStatus(status) {
    let button = $("#changePublicSelectionPm");
    if (status == "select") {
        button.attr("data-button-state", "select");
        let selectText = button.attr("data-select-button-value-text");
        button.html(selectText);
        button.addClass("status-select");
        button.removeClass("status-deselect");
    } else if (status == "deselect") {
        button.attr("data-button-state", "deselect");
        let deselectText = button.attr("data-deselect-button-value-text");
        button.html(deselectText);
        button.removeClass("status-select");
        button.addClass("status-deselect");
    }
}
